
import { Component, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";

@Component({})
export default class NextMaintenanceDatePicker extends Vue {
  pickerOptions: any = {
    shortcuts: [
      {
        text: t("v213.after-3-months"),
        onClick(picker) {
          const now = dayjs();
          const end = now.add(3, "M");
          picker.$emit("pick", end.toDate());
        }
      },
      {
        text: t("v213.after-6-months"),
        onClick(picker) {
          const now = dayjs();
          const end = now.add(6, "M");
          picker.$emit("pick", end.toDate());
        }
      },
      {
        text: t("v213.after-12-months"),
        onClick(picker) {
          const now = dayjs();
          const end = now.add(12, "M");
          picker.$emit("pick", end.toDate());
        }
      }
    ]
  };
}
